<template>
  <div class="ffcs-img">
    <img :src="URL" alt="" />
  </div>
</template>
<script>
import { getImgUrl } from "@/api/service.js";
export default {
  name: "FfcsImg",
  props: {
    fileCode: "",
  },
  data() {
    return {
      URL: "",
    };
  },
  watch: {
    fileCode: {
      handler(val) {
        if (val == "") return;
        const data = [val];
        getImgUrl(data).then((res) => {
          // const ip= ''
          const ip =
            process.env.NODE_ENV == "production" ? "" : "http://www.ffasc.cn";
          this.URL = ip + res.data[val].fileHttpUrl;
        });
      },
      immediate:true
    },
  },
};
</script>
<style>
.ffcs-img img {
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/FfcsImg/index.vue